var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"ornement",class:_vm.position,attrs:{"src":_vm.source,"alt":_vm.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }